/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

let appInsights: ApplicationInsights;

/**
 * Create the App Insights Telemetry Service
 * @return {{appInsights: Object, initialize: Function}} - Object
 */
const createTelemetryService = (): { appInsights: ApplicationInsights; initialize: Function } => {
  /**
   * Initialize the Application Insights class
   * @param {string} instrumentationKey - Application Insights Instrumentation Key
   * @return {void}
   */
  const initialize = (instrumentationKey: string): void => {
    if (!instrumentationKey) {
      throw new Error("Instrumentation key not provided for app insights");
    }

    appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: instrumentationKey,
        disableFetchTracking: false,
        extensions: [],
        extensionConfig: {},
        enableCorsCorrelation: true, // for correlating with backend
        enableAutoRouteTracking: true,
      },
    });

    appInsights.loadAppInsights();
    appInsights.trackPageView();
  };

  return { appInsights, initialize };
};

export const ai = createTelemetryService();
export const getAppInsights = (): ApplicationInsights => appInsights;
